export default __webpack_public_path__ + "static/media/word.cf6e656f.svg";